class OrderHub extends HTMLElement {
  connectedCallback() {
    this.identifyEndpoint = this.dataset.identifyEndpoint;
    this.form = this.querySelector('[data-order-hub-identify]');
    this.panels = Array.from(this.querySelectorAll('[data-order-hub-panel]'));

    this.form.addEventListener('submit', (event) => this.identify(event));
  }

  async identify(event) {
    event.preventDefault();
    if (!this.form.reportValidity()) return;
    const submit = this.form.querySelector('[type="submit"]');
    submit.disabled = true;
    try {
      const response = await fetch(this.identifyEndpoint, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(this.form))),
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (response.status >= 500) throw new Error('SERVICE_UNAVAILABLE');
      // Deliberately identical for zero, one, or multiple matches. The request
      // must never confirm that an order or email exists.
      this.show('sent');
    } catch {
      this.show('service');
    } finally {
      submit.disabled = false;
    }
  }

  show(name) {
    this.panels.forEach((panel) => { panel.hidden = panel.dataset.orderHubPanel !== name; });
  }
}

if (!customElements.get('order-hub')) customElements.define('order-hub', OrderHub);
